export const MAX_UPLOAD_LIMIT_MB = 64;

export const sysConfig = {
  isRemoteLoggingEnabled: process.env.REACT_APP_REMOTE_LOGGING_ENABLED,
};

export const isRemoteLoggingEnabled = () => {
  return sysConfig.isRemoteLoggingEnabled === 'true';
};
